<template>
    <div class="bg-white shadow-o rounded-md sm:rounded-lg px-6 pt-5 pb-8 lg:px-8 lg:pb-12">
        <div v-for="(step, key) in steps" class="mt-5" :key="key">
            <radio-group 
                v-show="isCurrentStep(step.name)" 
                @input="nextStep" 
                @select-family-dropdown="nextStep" 
                :name="step.name"
                v-model="form[step.name].value" 
                :label="form[step.name].question"
                :full-options="form[step.name].fullOptions"
                :options="form[step.name].options"
                :flow-icon-version="flowIconVersion"
                :direct-to-flow-user="directToFlowUser">
            </radio-group>
        </div>
        <div class="flex justify-between mt-8" v-if="currentStep">
            <a href="javascript:void(0)" @click="goBack" class="text-gray-500 hover:underline text-sm">
                &lt; Back
            </a>
        </div>
    </div>
</template>

<script>

import RadioGroup from "../RadioGroup";

export default {
    name: "Questions",
    components: {
        RadioGroup
    },
    props: {
        form: {
            type: Object,
            default: () => {
            },
        },
        steps: {
            type: Array,
            default: () => [],
        },
        flowIconVersion: {
            type: Boolean,
            default: false
        },
        directToFlowUser: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            quote: this.$store.state.quote,
            currentStep: 0
        }
    },
    methods: {
        isCurrentStep(stepName) {
            return this.steps[this.currentStep].name === stepName
        },
        goBack() {
            this.currentStep--
        },
        async updateSteps(coverType) {
            if(coverType.value == "personalCover") {
                this.steps[1] = {name: 'people_form'}
            } else {
                this.steps[1] = {name: 'vehicle'}
            }
        },
        async nextStep(cover_type) {

            this.$emit('update-quote', true);

            if (this.steps[this.currentStep].name === 'cover_type') {
                let slugArg;
                if(cover_type === 'personalCover') {
                    this.form.vehicles = []
                    await this.$store.commit('RESET_VEHICLES')
                    slugArg = "personal-bespoke-monthly"
                } else {
                    this.form.people = []
                    await this.$store.commit('RESET_PEOPLE')
                    slugArg = 'bespoke-monthly'
                }

                if(window.package.slug !== slugArg){

                    try {
                        const response = await this.$http
                            .post(window.apiUrl + '/quote/select-package', {
                                slug: slugArg,
                            });

                        if (response && response.data && response.data.data) {
                            const packageData = response.data.data;
                            window.package = packageData;
                            this.$store.commit('SET_QUOTE', {
                                ...this.quote, 
                                package: packageData,
                                package_id: packageData.packages_id
                            });
                        }
                    } catch (error) {
                        console.error("Error making API request:", error);
                    }
                }
            }

            // Skip local question if nationwide is selected
            if (this.steps[this.currentStep].name === 'nationwide' && this.shouldSkipLocalQuestion()) {
                this.$emit('complete-questions', true);
                return;
            }

            // Move to next step
            if ((this.currentStep + 1) < this.steps.length) {
                // More vehicles than allowed: redirect to call us
                if (this.steps[this.currentStep].name === 'vehicle' && this.form.vehicle.value > this.form.vehicle.max) {
                    this.$emit('call-us', true);
                    return;
                }
                this.currentStep++;
                return;
            }

            this.$emit('complete-questions', true);
        },
        shouldSkipLocalQuestion(){
            return this.form.nationwide.value || this.isTermMonthly()
        },
        trackStep(step) {
            this.apiUpdateCurrentSplitTestStep(step)
        },
    },
    mounted(){
        this.currentStep = 0
        if(this.currentStep = 0) {
            this.$store.commit('RESET_PEOPLE')
        }
   
        const splitTestStep = this.form[this.steps[0]?.name]?.splitTestStep

        if (splitTestStep) {
            this.trackStep(splitTestStep)
        }

        // Direct to flow show call us.
        if(this.directToFlowUser){
            if(document.getElementById('discount-banner')){
                // Dont show if timer
            }
            else {
                if(document.getElementById('callus-mobile')){
                    document.getElementById('callus-mobile').classList.remove('hidden')
                }

                if(document.getElementById('callus-desktop')){
                    document.getElementById('callus-desktop').classList.remove('hidden')
                }
            }
        }

        this.$nextTick(function () {
            this.$emit('load-trustpilot', true)
        })
    },
    watch: {
        'form.cover_type': {
            handler(newValue) {

                if (newValue && newValue.value) {
                    const selectedOption = newValue.options.find(option => option.value === newValue.value);

                    if (selectedOption) {
                        const coverType = {
                            value: selectedOption.value
                        };
                        this.updateSteps(coverType);
                    }
                }
            },
            deep: true, 
        },
        currentStep(index) {
            // Get the current step then call apiUpdateCurrentSplitTestStep to update the users current step.
            const step = this.steps?.[index]
            const stepName = step?.name
            const splitTestStep = this.form?.[stepName]?.splitTestStep

            if (splitTestStep) {
                this.trackStep(splitTestStep)
            }
        }
    },
}
</script>

<style scoped>

</style>
